import { resolveImageUrl } from './imageUrl';

function upsertMeta({ attr, key, content }) {
  if (!key) return;

  const selector = `meta[${attr}="${key}"]`;
  let tag = document.head.querySelector(selector);

  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }

  if (content !== undefined && content !== null) {
    tag.setAttribute('content', content);
  }
}

function upsertCanonical(url) {
  if (!url) return;

  let tag = document.head.querySelector('link[rel="canonical"]');
  if (!tag) {
    tag = document.createElement('link');
    tag.setAttribute('rel', 'canonical');
    document.head.appendChild(tag);
  }

  tag.setAttribute('href', url);
}

export function applySocialMeta({
  title,
  description,
  url,
  image,
  type = 'article',
  siteName = 'GUHSO',
}) {
  if (title) {
    document.title = title.toLowerCase().includes(siteName.toLowerCase())
      ? title
      : `${title} | ${siteName}`;
  }

  const normalizedImage = resolveImageUrl(image);
  const normalizedUrl = url || window.location.href;

  upsertMeta({ attr: 'name', key: 'description', content: description || '' });

  upsertMeta({ attr: 'property', key: 'og:type', content: type });
  upsertMeta({ attr: 'property', key: 'og:site_name', content: siteName });
  upsertMeta({ attr: 'property', key: 'og:title', content: title || siteName });
  upsertMeta({ attr: 'property', key: 'og:description', content: description || '' });
  upsertMeta({ attr: 'property', key: 'og:url', content: normalizedUrl });
  upsertMeta({ attr: 'property', key: 'og:image', content: normalizedImage || '' });

  upsertMeta({ attr: 'name', key: 'twitter:card', content: normalizedImage ? 'summary_large_image' : 'summary' });
  upsertMeta({ attr: 'name', key: 'twitter:title', content: title || siteName });
  upsertMeta({ attr: 'name', key: 'twitter:description', content: description || '' });
  upsertMeta({ attr: 'name', key: 'twitter:image', content: normalizedImage || '' });

  upsertCanonical(normalizedUrl);
}
